import { NgModule } from '@angular/core';
import { FbqGgCartAddEntrySuccessEventBuilder } from './fbq-gg-cart-add-entry-success-event.builder';

@NgModule({})
export class FbqGgCartAddEntrySuccessEventModule {
  constructor(_fbqGgCartAddEntrySuccessEventBuilder: FbqGgCartAddEntrySuccessEventBuilder) {}
}
